import React from "react";
import { Provider } from "react-redux";
import Store from "./redux/store";
import { BrowserRouter, Routes, Route, Outlet, Link } from "react-router-dom";
import {
  Layout,
  Space,
  Image,
  FloatButton,
  Row,
  Col,
  ConfigProvider,
} from "antd";
import Mmenu from "./components/mmenu";
import ScrollToTop from "./components/scrolltotop";
import Home from "./pages/home";
import Aboutme from "./pages/aboutme";
import Visdev from "./pages/visdev";
import Gameart from "./pages/gameart";
import Illustration from "./pages/illustration";
import TangTen from "./pages/gallery/TangTen";
import Monster from "./pages/gallery/Monster";
import Faceless from "./pages/gallery/Faceless";
import Ciga from "./pages/gallery/Ciga";
import Global from "./pages/gallery/Global";
import Indie from "./pages/gallery/Indie";
import Time from "./pages/gallery/Time";
import Phantom from "./pages/gallery/Phantom";
import Afters from "./pages/gallery/Afters";
import LinkedinImg from "./assets/images/Icon_Linkedin.png";
import InstagramImg from "./assets/images/Icon_Instagram.png";
import "./App.css";

const { Header, Content, Footer } = Layout;

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WholePage />}>
          <Route path="/home" element={<Home />} />
          <Route path="/aboutme" element={<Aboutme />} />
          <Route path="/visdev" element={<Visdev />} />
          <Route path="/gameart" element={<Gameart />} />
          <Route path="/Illustration" element={<Illustration />} />
          <Route path="/TangTen" element={<TangTen />} />
          <Route path="/Monster" element={<Monster />} />
          <Route path="/Faceless" element={<Faceless />} />
          <Route path="/Ciga" element={<Ciga />} />
          <Route path="/Global" element={<Global />} />
          <Route path="/Indie" element={<Indie />} />
          <Route path="/Time" element={<Time />} />
          <Route path="/Phantom" element={<Phantom />} />
          <Route path="/Afters" element={<Afters />} />
          <Route path="*" element={<Home />} />
          <Route path="/" element={<Home />} />
        </Route>
        <Route path="*" element={<WholePage />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

function WholePage() {
  return (
    <Provider store={Store}>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token，影响范围大
            colorPrimary: "#8d8273",
            // colorText: "rgba(141,130,115,0.88)", //,"rgba(80,70,60,0.88)"
            // fontFamily: "Arial, Helvetica, sans-serif",
            // fontSize: "1.2em",

            // 派生变量，影响范围小
            // colorBgContainer: "#f6ffed",
          },
          components: {
            Layout: {
              bodyBg: "#ffffff",
              headerBg: "#ffffff",
              footerBg: "#ffffff",
            },
            Menu: {
              // fontFamily: "Trebuchet MS",
              itemBg: "", //菜单项背景色，透明色，默认#ffffff
              //itemSelectedBg: "#ff0000", //菜单项选中态背景色
              itemColor: "#8d8273", //菜单字体颜色
              horizontalItemSelectedColor: "#50463C", //水平菜单项文字选中颜色
              itemHoverColor: "#50463C", //菜单字体鼠标悬浮颜色
              // itemSelectedColor: "#ffffff", //菜单字体选中颜色，浮动菜单中选中项的字体色
              itemSelectedColor: "#50463C", //菜单字体选中颜色，浮动菜单中选中项的字体色
              itemSelectedBg: "", //菜单项选中态背景色，浮动菜单中选中项的背景色
              // itemSelectedBg: "#8d8273", //菜单项选中态背景色，浮动菜单中选中项的背景色
              itemHoverBg: "",
              popupBg: "#ffffff", //小页面浮动菜单颜色
              // popupBg: "rgba(255,255,0,0.1)",
              // popupBg: "transparent",
              activeBarHeight: 0, //菜单项指示条高度，默认2，菜单底部的横条
              subMenuItemSelectedColor: "#50463C", //子菜单内有选中项时，子菜单标题色，收缩图标的颜色
            },
          },
        }}
      >
        <ScrollToTop />
        <Layout className="layout">
          <Header className="header">
            <Row gutter={0}>
              <Col xs={0} sm={0} md={0} lg={1} xl={1}></Col>
              <Col xs={24} sm={24} md={24} lg={22} xl={22}>
                <Row gutter={0}>
                  <Col xs={12} sm={8} md={6} lg={5} xl={5} className="logoText">
                    <Link to="/home" className="link">
                      Morna(Zixie) Yang
                    </Link>
                  </Col>
                  <Col xs={6} sm={4} md={3} lg={2} xl={2}>
                    <Space size="large">
                      <a
                        href="https://www.linkedin.com/in/morna-yang-b17b69290/"
                        target="_blank"
                      >
                        <Image
                          src={LinkedinImg}
                          alt="Linkedin Icon"
                          width={20}
                          preview={false}
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/morna_zy/"
                        target="_blank"
                      >
                        <Image
                          src={InstagramImg}
                          alt="Instagram Icon"
                          width={20}
                          preview={false}
                        />
                      </a>
                    </Space>
                  </Col>
                  <Col
                    className="headerMenu"
                    xs={6}
                    sm={12}
                    md={15}
                    lg={17}
                    xl={17}
                  >
                    <div className="menuDiv">
                      <Mmenu />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={0} sm={0} md={0} lg={1} xl={1}></Col>
            </Row>
          </Header>
          <Content className="content">
            <Row gutter={0}>
              <Col span={24}>
                <Outlet />
                <FloatButton.BackTop />
              </Col>
            </Row>
          </Content>
          <Footer className="footer">
            <Row gutter={0}>
              <Col xs={0} sm={0} md={0} lg={1} xl={2}></Col>
              <Col xs={24} sm={24} md={24} lg={22} xl={20}>
                <Row gutter={0}>
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="footerLeft"
                  >
                    <div>Morna(Zixie) Yang</div>
                    <div className="paddTop10">
                      <a
                        href="mailto:morna0427@gmail.com"
                        className="linkBlack"
                      >
                        morna0427@gmail.com
                      </a>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="footerRight"
                  >
                    <div>@2025 by Zixie Yang</div>
                    <div className="paddTop20">All Rights Reserverd</div>
                  </Col>
                </Row>
              </Col>
              <Col xs={0} sm={0} md={0} lg={1} xl={2}></Col>
            </Row>
          </Footer>
        </Layout>
      </ConfigProvider>
    </Provider>
  );
}
